const ClientHistoryConstants = {
  GLOBAL: "global",

  URL_FILTRO:"?filtro=",
  URL_PARAMS:"&page=1&requests=20&orderby=numeroDocumento&order=false",
}
export default ClientHistoryConstants